import { type Liff } from '@line/liff'
import { VStack } from '@pets-ui/VStack/VStack'
import { type ReactNode } from 'react'
import { useContextCosign } from '../../useContextCosign'
import { Terms } from '../Terms'
import { ButtonLogin } from './ButtonLogin'
import { DividerOr } from './DividerOr'
import { InputInternationalPhoneNumber } from './InputInternationalPhoneNumber'
import { LoginPromotionStats, type LoginPromotionStatsProps } from './LoginPromotionStats'
import { LoginPromotionTip } from './LoginPromotionTip'
import { LogoElectronicCommerce } from './Logo/LogoElectronicCommerce'
import { ThirtyPartyLogin, type ThirtyPartyLoginVariant } from './ThirtyPartyLogin'
import { TitleLogin } from './TitleLogin'
import { useContextLogin } from './useContextLogin'

export interface LoginCustomizationProps {
  promoStats?: LoginPromotionStatsProps
  guestCheckoutSlot?: ReactNode
  buttonTitle?: string
  hideTitle?: boolean
  hidePromotion?: boolean
  thirdPartyVariant?: ThirtyPartyLoginVariant
}

interface LoginProps extends LoginCustomizationProps {
  liff?: Liff
}

export const Login = ({ liff, promoStats, guestCheckoutSlot, buttonTitle, hideTitle, hidePromotion, thirdPartyVariant }: LoginProps) => {
  const { phone, setPhone, phoneError, validatePhone, countryCode, setCountryCode } = useContextLogin()
  const { customLogo, projectCode, environment } = useContextCosign()
  const logo = customLogo ?? projectCode

  return (
    <>
      <LogoElectronicCommerce logo={logo} mb={hideTitle ? 5 : 2} />
      {!hideTitle && <TitleLogin />}
      <InputInternationalPhoneNumber
        phone={phone}
        setPhone={setPhone}
        phoneError={phoneError}
        validatePhone={validatePhone}
        countryCode={countryCode}
        setCountryCode={setCountryCode}
      />
      <VStack gap={3}>
        <ButtonLogin title={buttonTitle} />
        {!hidePromotion && (promoStats
          ? <LoginPromotionStats {...promoStats} />
          : (environment === 'wordPress' && <LoginPromotionTip />))}
        {guestCheckoutSlot}
      </VStack>
      <DividerOr />
      <ThirtyPartyLogin liff={liff} variant={thirdPartyVariant} />
      <Terms />
    </>
  )
}
